import { ThemedStyleFn } from '~src/hooks/useStyles';
import { fadeInKeyframes } from '~src/styles/animations';

export const styleFn: ThemedStyleFn = (theme) => ({
  table: {
    '.ant-table-row': {
      animation: `${fadeInKeyframes} 0.3s ease-out`,
      cursor: 'pointer',

      '&.unfinished > td': {
        color: 'rgba(0, 0, 0, 0.25)',
      },
    },
  },
  filterWrapper: {
    gap: '5px',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    margin: '0 15px',
  },
  filterIconWrapper: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    gap: '10px',
  },
  filterItemWrapper: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    gap: 20,
  },
  buttonDiv: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    type: 'button',
    cursor: 'pointer',
    marginLeft: 4,
    padding: '2px 10px',
    ':hover': {
      backgroundColor: theme.colors.gray,
      borderRadius: 9,
    },
  },
  iconsHeader: {
    fontSize: '20px',
    color: theme.colors.primary,
    transition: '0.3s',
  },
  tenderActionBtnIcon: {
    marginRight: '6px',
  },

  actionsContainer: {
    display: 'flex',
    position: 'absolute',
    right: '6px',
    top: '6px',
  },

  blockContainer: {
    position: 'relative',
  },

  printContainer: {
    position: 'absolute',
    zIndex: -1,
    opacity: 0,
  },
  printTable: { padding: '20px' },

  // tag color-related styles
  yellow: {
    backgroundColor: theme.colors.yellow,
  },
  green: {
    backgroundColor: theme.colors.green,
  },
  lightGray: {
    backgroundColor: theme.colors.lightGray,
  },
  gray: {
    backgroundColor: theme.colors.gray,
  },
  red: {
    backgroundColor: theme.colors.red,
  },
  transparent: {
    border: `1px solid ${theme.colors.lightGray}`,
  },
});
